export const styles = {
  npsQuestionWrapper: {
    height: '100%',
    width: '100%',
    px: 3,
    gap: 2,
    overflowY: 'auto',
  },
};
